"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _translate = _interopRequireDefault(require("./../translate"));

var _modal = _interopRequireDefault(require("./../modal"));

var _dataSelectRow = _interopRequireDefault(require("./data-select-row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var pad = function pad(nr) {
  return ('0' + nr).slice(-2);
};

var formatDate = function formatDate(dateStr) {
  var date = new Date(dateStr);
  return "".concat(pad(date.getDate()), ".").concat(pad(date.getMonth() + 1)) + ".".concat(date.getFullYear(), " - ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()));
};

var cookieLeft = 'SBV/resolve/left-side',
    cookieRight = 'SBV/resolve/right-side';

var ResolveDuplicates = /*#__PURE__*/function (_React$Component) {
  _inherits(ResolveDuplicates, _React$Component);

  function ResolveDuplicates(props) {
    var _this;

    _classCallCheck(this, ResolveDuplicates);

    _this = _possibleConstructorReturn(this, (ResolveDuplicates.__proto__ || Object.getPrototypeOf(ResolveDuplicates)).call(this, props));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.onSelectSide = _this.onSelectSide.bind(_assertThisInitialized(_this));
    _this.removeA = _this.removeA.bind(_assertThisInitialized(_this));
    _this.removeB = _this.removeB.bind(_assertThisInitialized(_this));
    _this.openModal = _this.openModal.bind(_assertThisInitialized(_this));
    _this.closeModal = _this.closeModal.bind(_assertThisInitialized(_this));
    _this.closeModalSuccess = _this.closeModalSuccess.bind(_assertThisInitialized(_this));
    _this.closeModalNotPossible = _this.closeModalNotPossible.bind(_assertThisInitialized(_this));
    _this.state = {
      sideA: {},
      sideB: {},
      userSelected: false,
      farmSelected: false,
      brunchSelected: false,
      schubSelected: false,
      vomhofSelected: false,
      lockpfostenSelected: false,
      stallvisiteSelected: false,
      tohSelected: false,
      lgwSelected: false,
      isLoading: false,
      isResolving: false,
      resolveDuplicatesConfirmModalOpen: false,
      resolveDuplicatesSuccessModalOpen: false,
      resolveDuplicatesNotPossibleModalOpen: false
    };
    _this.merge = {};
    _this.cleanup = {};
    return _this;
  }

  _createClass(ResolveDuplicates, [{
    key: "openModal",
    value: function openModal() {
      // check if at a farm is selected if at least one project is selected. otherwhise the user would try to
      // add projects to a farm with id 0 and the information would be lost
      var _this$merge = this.merge,
          brunch = _this$merge.brunch,
          schub = _this$merge.schub,
          vomhof = _this$merge.vomhof,
          lockpfosten = _this$merge.lockpfosten,
          stallvisite = _this$merge.stallvisite,
          toh = _this$merge.toh,
          lgw = _this$merge.lgw,
          projectSelected = brunch || schub || vomhof || lockpfosten || stallvisite || toh || lgw;

      if (!this.merge.farm && projectSelected) {
        this.setState({
          resolveDuplicatesNotPossibleModalOpen: true
        });
        return;
      }

      this.setState({
        resolveDuplicatesConfirmModalOpen: true
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        resolveDuplicatesConfirmModalOpen: false
      });
    }
  }, {
    key: "closeModalSuccess",
    value: function closeModalSuccess() {
      this.setState({
        resolveDuplicatesSuccessModalOpen: false
      });
    }
  }, {
    key: "closeModalNotPossible",
    value: function closeModalNotPossible() {
      this.setState({
        resolveDuplicatesNotPossibleModalOpen: false
      });
    }
  }, {
    key: "prepareData",
    value: function prepareData(data) {
      var _this2 = this;

      var side = {},
          projects = ['brunch', 'lockpfosten', 'schub', 'stallvisite', 'vomhof', 'toh', 'lgw'];
      side.user = {
        id: data.user.id,
        data: [{
          label: this.props.t('username'),
          value: data.user.username
        }, {
          label: this.props.t('name'),
          value: ((data.user.first_name || '') + ' ' + (data.user.last_name || '')).trim()
        }, {
          label: this.props.t('email'),
          value: data.user.email
        }, {
          label: this.props.t('register date'),
          value: formatDate(new Date(data.user.date_register))
        }]
      };

      if (data.farm.id) {
        side.farm = {
          id: data.farm.id,
          data: [{
            label: this.props.t('farm name'),
            value: data.farm.farmname
          }, {
            label: this.props.t('name'),
            value: ((data.farm.first_name || '') + ' ' + (data.farm.last_name || '')).trim()
          }, {
            label: this.props.t('street'),
            value: (data.farm.street || '').trim()
          }, {
            label: this.props.t('city'),
            value: ((data.farm.zip || '') + ' ' + (data.farm.city || '')).trim()
          }]
        };
      } else {
        side.farm = {
          id: '',
          data: [{
            message: this.props.t('no farm information')
          }]
        };
      }

      projects.forEach(function (projectName) {
        if (data[projectName].id) {
          side[projectName] = {
            id: data[projectName].id,
            data: [{
              label: _this2.props.t('register date'),
              value: formatDate(data[projectName].date_create)
            }]
          };
        } else {
          side[projectName] = {
            id: '',
            data: [{
              message: _this2.props.t('No Projectregistration')
            }]
          };
        }
      });
      return side;
    }
  }, {
    key: "load",
    value: function load() {
      var _this3 = this;

      this.setState({
        isLoading: true
      });

      var userIdA = _jsCookie.default.get(cookieLeft),
          userIdB = _jsCookie.default.get(cookieRight),
          aLoaded = false,
          bLoaded = false;

      if (userIdA !== undefined) {
        fetch("/api/".concat(this.props.i18n.language, "/merge-data/").concat(userIdA), {
          credentials: 'include'
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          _this3.setState({
            sideA: _this3.prepareData(json),
            isLoading: aLoaded && bLoaded
          });
        }).catch(function (err) {
          void 0;
        });
      } else {
        aLoaded = true;
      }

      if (userIdB !== undefined) {
        fetch("/api/".concat(this.props.i18n.language, "/merge-data/").concat(userIdB), {
          credentials: 'include'
        }).then(function (response) {
          return response.json();
        }).then(function (json) {
          _this3.setState({
            sideB: _this3.prepareData(json),
            isLoading: aLoaded && bLoaded
          });
        }).catch(function (err) {
          void 0;
        });
      } else {
        bLoaded = true;
      } // In case no users were selected


      if (aLoaded && bLoaded) {
        this.setState({
          isLoading: false
        });
      }
    }
  }, {
    key: "onSelectSide",
    value: function onSelectSide(e) {
      switch (e.name) {
        case 'user-select':
          this.setState({
            userSelected: true
          });
          this.merge.id = e.checkedValue;
          this.cleanup.id = e.uncheckedValue;
          break;

        case 'farm-select':
          this.setState({
            farmSelected: true
          });
          this.merge.farm = e.checkedValue;
          this.cleanup.farm = e.uncheckedValue;
          break;

        case 'brunch-select':
          this.setState({
            brunchSelected: true
          });
          this.merge.brunch = e.checkedValue;
          this.cleanup.brunch = e.uncheckedValue;
          break;

        case 'schub-select':
          this.setState({
            schubSelected: true
          });
          this.merge.schub = e.checkedValue;
          this.cleanup.schub = e.uncheckedValue;
          break;

        case 'vomhof-select':
          this.setState({
            vomhofSelected: true
          });
          this.merge.vomhof = e.checkedValue;
          this.cleanup.vomhof = e.uncheckedValue;
          break;

        case 'lockpfosten-select':
          this.setState({
            lockpfostenSelected: true
          });
          this.merge.lockpfosten = e.checkedValue;
          this.cleanup.lockpfosten = e.uncheckedValue;
          break;

        case 'stallvisite-select':
          this.setState({
            stallvisiteSelected: true
          });
          this.merge.stallvisite = e.checkedValue;
          this.cleanup.stallvisite = e.uncheckedValue;
          break;

        case 'toh-select':
          this.setState({
            tohSelected: true
          });
          this.merge.toh = e.checkedValue;
          this.cleanup.toh = e.uncheckedValue;
          break;

        case 'lgw-select':
          this.setState({
            lgwSelected: true
          });
          this.merge.lgw = e.checkedValue;
          this.cleanup.lgw = e.uncheckedValue;
          break;
      }
    }
  }, {
    key: "removeA",
    value: function removeA() {
      _jsCookie.default.remove(cookieLeft);

      this.setState({
        sideA: {},
        userSelected: false,
        farmSelected: false,
        brunchSelected: false,
        schubSelected: false,
        vomhofSelected: false,
        lockpfostenSelected: false,
        stallvisiteSelected: false,
        tohSelected: false,
        lgwSelected: false
      });
    }
  }, {
    key: "removeB",
    value: function removeB() {
      _jsCookie.default.remove(cookieRight);

      this.setState({
        sideB: {},
        userSelected: false,
        farmSelected: false,
        brunchSelected: false,
        schubSelected: false,
        vomhofSelected: false,
        lockpfostenSelected: false,
        stallvisiteSelected: false,
        tohSelected: false,
        lgwSelected: false
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this4 = this;

      // Prepare JSON data
      var mergeData = JSON.stringify({
        merge: this.merge,
        cleanup: this.cleanup
      }, function (key, value) {
        if (value === '') {
          return null;
        } else {
          return value;
        }
      });
      this.setState({
        isResolving: true
      });
      fetch("/api/".concat(this.props.i18n.language, "/merge-data"), {
        credentials: 'include',
        method: 'POST',
        body: mergeData,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        if (response.status === 200) {
          // Clear cookies
          _jsCookie.default.remove(cookieLeft);

          _jsCookie.default.remove(cookieRight);

          _this4.setState({
            resolveDuplicatesConfirmModalOpen: false,
            // Open success modal
            resolveDuplicatesSuccessModalOpen: true,
            // This will 'cleanup' the view
            sideA: {},
            sideB: {},
            userSelected: false,
            farmSelected: false,
            brunchSelected: false,
            schubSelected: false,
            vomhofSelected: false,
            lockpfostenSelected: false,
            stallvisiteSelected: false,
            tohSelected: false,
            lgwSelected: false,
            isResolving: false
          });
        }
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
    /*eslint-disable no-extra-boolean-cast*/

  }, {
    key: "render",
    value: function render() {
      var t = this.props.t,
          sideA = this.state.sideA,
          sideB = this.state.sideB,
          enableResolveButton = this.state.userSelected && this.state.farmSelected && this.state.brunchSelected && this.state.schubSelected && this.state.vomhofSelected && this.state.lockpfostenSelected && this.state.stallvisiteSelected && this.state.tohSelected && this.state.lgwSelected;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "resolve-duplicates"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, t('Resolve duplicates'), this.state.isLoading ? /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      }) : null), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-1"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-6 space-1"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--small",
        onClick: this.removeA,
        disabled: !!!sideA.user
      }, this.props.t('remove from clipboard'))), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-6 space-1"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--small",
        onClick: this.removeB,
        disabled: !!!sideB.user
      }, this.props.t('remove from clipboard')))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-3"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.user,
        valueA: sideA.user ? sideA.user.id : '',
        idA: "user-a",
        labelA: t('User') + ' A',
        detailLinkA: sideA.user ? '/user/' + sideA.user.id : '',
        dataA: sideA.user ? sideA.user.data : [],
        disabledB: !!!sideB.user,
        valueB: sideB.user ? sideB.user.id : '',
        idB: "user-b",
        labelB: t('User') + ' B',
        detailLinkB: sideB.user ? '/user/' + sideB.user.id : '',
        dataB: sideB.user ? sideB.user.data : [],
        name: "user-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-3"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.farm,
        valueA: sideA.farm ? sideA.farm.id : '',
        idA: "farm-a",
        labelA: t('farm') + ' A',
        detailLinkA: sideA.farm && sideA.farm.id ? '/farm/' + sideA.farm.id : '',
        dataA: sideA.farm ? sideA.farm.data : [],
        disabledB: !!!sideB.farm,
        valueB: sideB.farm ? sideB.farm.id : '',
        idB: "farm-b",
        labelB: t('farm') + ' B',
        detailLinkB: sideB.farm && sideB.farm.id ? '/farm/' + sideB.farm.id : '',
        dataB: sideB.farm ? sideB.farm.data : [],
        name: "farm-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-2"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.brunch,
        valueA: sideA.brunch ? sideA.brunch.id : '',
        idA: "brunch-a",
        labelA: t('1st of august brunch'),
        detailLinkA: sideA.brunch && sideA.brunch.id ? '/brunch-release/' + sideA.brunch.id : '',
        dataA: sideA.brunch ? sideA.brunch.data : [],
        disabledB: !!!sideB.brunch,
        valueB: sideB.brunch ? sideB.brunch.id : '',
        idB: "brunch-b",
        labelB: t('1st of august brunch'),
        detailLinkB: sideB.brunch && sideB.brunch.id ? '/brunch-release/' + sideB.brunch.id : '',
        dataB: sideB.brunch ? sideB.brunch.data : [],
        name: "brunch-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-2"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.schub,
        valueA: sideA.schub ? sideA.schub.id : '',
        idA: "schub-a",
        labelA: t('Education on the farm'),
        detailLinkA: sideA.schub && sideA.schub.id ? '/schub-release/' + sideA.schub.id : '',
        dataA: sideA.schub ? sideA.schub.data : [],
        disabledB: !!!sideB.schub,
        valueB: sideB.schub ? sideB.schub.id : '',
        idB: "schub-b",
        labelB: t('Education on the farm'),
        detailLinkB: sideB.schub && sideB.schub.id ? '/schub-release/' + sideB.schub.id : '',
        dataB: sideB.schub ? sideB.schub.data : [],
        name: "schub-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-2"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.vomhof,
        valueA: sideA.vomhof ? sideA.vomhof.id : '',
        idA: "vomhof-a",
        labelA: t('Online direct marketing'),
        detailLinkA: sideA.vomhof && sideA.vomhof.id ? '/vomhof-release/' + sideA.vomhof.id : '',
        dataA: sideA.vomhof ? sideA.vomhof.data : [],
        disabledB: !!!sideB.vomhof,
        valueB: sideB.vomhof ? sideB.vomhof.id : '',
        idB: "vomhof-b",
        labelB: t('Online direct marketing'),
        detailLinkB: sideB.vomhof && sideB.vomhof.id ? '/vomhof-release/' + sideB.vomhof.id : '',
        dataB: sideB.vomhof ? sideB.vomhof.data : [],
        name: "vomhof-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-2"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.lockpfosten,
        valueA: sideA.lockpfosten ? sideA.lockpfosten.id : '',
        idA: "lockpfosten-a",
        labelA: t('Lockpfosten'),
        detailLinkA: sideA.lockpfosten && sideA.lockpfosten.id ? '/lockpfosten-release/' + sideA.lockpfosten.id : '',
        dataA: sideA.lockpfosten ? sideA.lockpfosten.data : [],
        disabledB: !!!sideB.lockpfosten,
        valueB: sideB.lockpfosten ? sideB.lockpfosten.id : '',
        idB: "lockpfosten-b",
        labelB: t('Lockpfosten'),
        detailLinkB: sideB.lockpfosten && sideB.lockpfosten.id ? '/lockpfosten-release/' + sideB.lockpfosten.id : '',
        dataB: sideB.lockpfosten ? sideB.lockpfosten.data : [],
        name: "lockpfosten-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-3"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.stallvisite,
        valueA: sideA.stallvisite ? sideA.stallvisite.id : '',
        idA: "stallvisite-a",
        labelA: t('stable visits'),
        detailLinkA: sideA.stallvisite && sideA.stallvisite.id ? '/stallvisite-release/' + sideA.stallvisite.id : '',
        dataA: sideA.stallvisite ? sideA.stallvisite.data : [],
        disabledB: !!!sideB.stallvisite,
        valueB: sideB.stallvisite ? sideB.stallvisite.id : '',
        idB: "stallvisite-b",
        labelB: t('stable visits'),
        detailLinkB: sideB.stallvisite && sideB.stallvisite.id ? '/stallvisite-release/' + sideB.stallvisite.id : '',
        dataB: sideB.stallvisite ? sideB.stallvisite.data : [],
        name: "stallvisite-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-3"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.toh,
        valueA: sideA.toh ? sideA.toh.id : '',
        idA: "toh-a",
        labelA: t('toh'),
        detailLinkA: sideA.toh && sideA.toh.id ? '/toh-release/' + sideA.toh.id : '',
        dataA: sideA.toh ? sideA.toh.data : [],
        disabledB: !!!sideB.toh,
        valueB: sideB.toh ? sideB.toh.id : '',
        idB: "toh-b",
        labelB: t('toh'),
        detailLinkB: sideB.toh && sideB.toh.id ? '/toh-release/' + sideB.toh.id : '',
        dataB: sideB.toh ? sideB.toh.data : [],
        name: "toh-select",
        onChange: this.onSelectSide
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 large-10 x-large-9 space-3"
      }, /*#__PURE__*/_react.default.createElement(_dataSelectRow.default, {
        disabledA: !!!sideA.lgw,
        valueA: sideA.lgw ? sideA.lgw.id : '',
        idA: "lgw-a",
        labelA: t('lgw'),
        detailLinkA: sideA.lgw && sideA.lgw.id ? '/lgw-release/' + sideA.lgw.id : '',
        dataA: sideA.lgw ? sideA.lgw.data : [],
        disabledB: !!!sideB.lgw,
        valueB: sideB.lgw ? sideB.lgw.id : '',
        idB: "lgw-b",
        labelB: t('lgw'),
        detailLinkB: sideB.lgw && sideB.lgw.id ? '/lgw-release/' + sideB.lgw.id : '',
        dataB: sideB.lgw ? sideB.lgw.data : [],
        name: "lgw-select",
        onChange: this.onSelectSide
      }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        disabled: !enableResolveButton,
        className: "btn",
        onClick: this.openModal
      }, t('resolve'))), /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "resolve-duplicates-confirm",
        isOpen: this.state.resolveDuplicatesConfirmModalOpen,
        closeHandler: this.closeModal,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "large space-3"
      }, this.props.t('are you sure')), this.state.isResolving ? /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "loader"
      })) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn",
        onClick: this.handleSubmit
      }, t('resolve')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.closeModal
      }, t('cancel')))), /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "resolve-duplicate-not-possible",
        isOpen: this.state.resolveDuplicatesNotPossibleModalOpen,
        closeHandler: this.closeModalNotPossible,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "large space-3"
      }, this.props.t('This merge process due to empty farm is not possible')), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.closeModalNotPossible
      }, t('close')))), /*#__PURE__*/_react.default.createElement(_modal.default, {
        id: "resolve-duplicates-success",
        isOpen: this.state.resolveDuplicatesSuccessModalOpen,
        closeHandler: this.closeModalSuccess,
        escClose: true,
        backgroundClickClose: true
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "large space-3"
      }, this.props.t('duplicates resolved successfully')), /*#__PURE__*/_react.default.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "btn",
        href: "/"
      }, t('To dashboard')), /*#__PURE__*/_react.default.createElement("button", {
        className: "btn btn--secondary",
        onClick: this.closeModalSuccess
      }, t('close')))));
    }
    /*eslint-enable no-extra-boolean-cast*/

  }]);

  return ResolveDuplicates;
}(_react.default.Component);

ResolveDuplicates.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  })
};

var _default = (0, _translate.default)(ResolveDuplicates);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/resolve-duplicates/index.js
// module id = 749
// module chunks = 0